import React, { Component } from "react";
import { Outlet } from "react-router-dom";
import { isDashboardLoginPath } from "../../utils/dashboardPaths";
import { isMobileUserAgent } from "../../utils/isMobileUserAgent";
import AppHeader from "../AppHeader/AppHeader";
import SidePanel from "./SidePanel/SidePanel";
import "./DashboardLayout.scss";

interface DashboardLayoutProps {
  pathname: string;
}

interface DashboardLayoutState {}

class DashboardLayout extends Component<DashboardLayoutProps, DashboardLayoutState> {
  constructor(props: DashboardLayoutProps) {
    super(props);
    this.state = {};
  }

  render(): React.JSX.Element {
    const { pathname } = this.props;
    const showSidePanel = !isMobileUserAgent() && !isDashboardLoginPath(pathname);
    const isLoginRoute = isDashboardLoginPath(pathname);

    return (
      <div className="dashboard-layout">
        <AppHeader variant="dashboard" />
        <div className="dashboard-layout-body">
          <div className="dashboard-layout-inner">
            {showSidePanel ? <SidePanel /> : null}
            <main
              className={
                isLoginRoute
                  ? "dashboard-layout-main dashboard-layout-main--login"
                  : "dashboard-layout-main"
              }
            >
              <Outlet />
            </main>
          </div>
        </div>
      </div>
    );
  }
}

export default DashboardLayout;
